import { Controller } from "@hotwired/stimulus"
import RenderJobChannel from "../../channels/render_job_channel"

export default class extends Controller {
  static targets = ["previewPlayer", "previewBtn", "renderBtn"]
  static values = { renderJobId: Number }

  connect() {
    if (this.hasRenderJobIdValue && this.renderJobIdValue) {
      this.subscribeToRenderJob()
    }
  }

  disconnect() {
    if (this.renderSubscription) {
      this.renderSubscription.unsubscribe()
      this.renderSubscription = null
    }
  }

  previewBtnTargetConnected(btn) {
    this.originalPreviewText = btn.textContent
    btn.addEventListener("click", () => {
      // Defer disabling so the form submits first
      setTimeout(() => {
        btn.disabled = true
        btn.textContent = "Assembling..."
        this.scheduleReset(btn, this.originalPreviewText)
      }, 0)
    })
  }

  renderBtnTargetConnected(btn) {
    this.originalRenderText = btn.textContent
    btn.addEventListener("click", () => {
      // Defer disabling so the form submits first
      setTimeout(() => {
        btn.disabled = true
        btn.textContent = "Submitting..."
        this.scheduleReset(btn, this.originalRenderText)
      }, 0)
    })
  }

  // --- Private ---

  subscribeToRenderJob() {
    this.renderSubscription = RenderJobChannel.subscribe(this.renderJobIdValue, {
      onCompleted: () => this.reloadPage(),
      onFailed: () => this.reloadPage(),
      onUpdate: (data) => {
        if (data.status === "completed" || data.status === "failed") {
          this.reloadPage()
        }
      }
    })
  }

  reloadPage() {
    if (typeof Turbo !== "undefined" && Turbo.visit) {
      Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }

  /**
   * Re-enable the button after a timeout as a safety net.
   * On normal flow the page redirects and buttons reset naturally.
   * This handles cases where the request fails without a redirect.
   */
  scheduleReset(btn, originalText) {
    setTimeout(() => {
      if (btn.disabled) {
        btn.disabled = false
        btn.textContent = originalText
      }
    }, 30000) // 30 second safety timeout
  }
}
